if (
  document.querySelector("div[data-has-mini-desserts]") != undefined ||
  document.querySelector("div[data-has-cukrovi]") != undefined
) {
  runCalendarCheck();
}

let cartItemsBody = document.querySelector(".cart-items__body");

let cartItemsHeaderObserver = new MutationObserver(function (mutations) {
  runCalendarCheck();

  // if (document.querySelector("div[data-has-mini-desserts]") == undefined) {
  //   revertCalendar();
  //   disableDaysForCukrovi();
  // }

  if (document.querySelector("div[data-has-cukrovi]") == undefined) {
    revertCalendar();
    // disableDaysForMiniDesserts();
  }
});

cartItemsHeaderObserver.observe(cartItemsBody, {
  attributes: false,
  childList: true,
  characterData: false,
  subtree: true,
});

let nextPrevBtns;
let picker;

function runCalendarCheck() {
  var observer = new MutationObserver(function (mutations) {
    if (
      document.contains(document.querySelector(".rmdp-day-picker")) &&
      document.querySelectorAll(".rmdp-day .sd").length > 0
    ) {
      let days = document.querySelectorAll(".rmdp-day .sd");
      picker = document.querySelector(".rmdp-day-picker");
      window.calendar = {
        current_page: 1,
        first_page_days_length: days.length,
        second_page_days_length: 5 - days.length,
      };
      nextPrevBtns = document.querySelectorAll(".prev_next_button");

      // if (document.querySelector("div[data-has-mini-desserts]") != undefined) {
      //   disableDaysForMiniDesserts();
      // }

      if (document.querySelector("div[data-has-cukrovi]") != undefined) {
        disableDaysForCukrovi();
      }

      nextPrevBtns?.forEach((btn) => {
        btn.addEventListener("click", (e) => handleNextPrevBtns(e));
      });
      observer.disconnect();

      const pickerObserver = new MutationObserver(function (mutations) {
        // if (
        //   document.querySelector("div[data-has-mini-desserts]") != undefined
        // ) {
        //   disableDaysForMiniDesserts();
        // }

        if (document.querySelector("div[data-has-cukrovi]") != undefined) {
          disableDaysForCukrovi();
        }
      });

      pickerObserver.observe(picker, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
      });
    }
  });

  observer.observe(document, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });
}

function handleNextPrevBtns(e) {
  if (e.target.classList.contains("next_header_btn")) {
    window.calendar.current_page += 1;
  }

  if (e.target.classList.contains("prev_header_btn")) {
    window.calendar.current_page -= 1;
  }
}

function disableDaysForMiniDesserts() {
  if (document.querySelector("div[data-has-mini-desserts]") == undefined) {
    return;
  }

  let arr = document.querySelectorAll(".rmdp-day .sd");
  if (window.calendar.current_page == 1) {
    if (window.calendar.first_page_days_length < 5) {
      // first page days length less than 5, will have to disable on next page as well
      action(arr, window.calendar.first_page_days_length);
    } else {
      // first page days length more than 5, take action on page 1 only
      action(arr, 5);
    }
  }
  if (window.calendar.current_page == 2) {
    action(arr, window.calendar.second_page_days_length);
  }

  function action(array, length) {
    if (
      document.querySelector("div[data-has-mini-desserts]") != undefined &&
      length > 0
    ) {
      for (let dd = 0; dd < length; dd++) {
        array[dd].closest(".rmdp-day").classList.add("rmdp-disabled");
        array[dd].closest(".rmdp-day").style.pointerEvents = "none";
      }
    } else {
      for (let dd = 0; dd < array.length; dd++) {
        array[dd].closest(".rmdp-day").classList.remove("rmdp-disabled");
        array[dd].closest(".rmdp-day").style.pointerEvents = "all";
      }
    }
  }
}

function disableDaysForCukrovi() {
  if (document.querySelector("div[data-has-cukrovi]") == undefined) {
    return;
  }

  let calendarHeader = document.querySelector(".rmdp-header-values");
  let array = document.querySelectorAll(".rmdp-day .sd");
  if (calendarHeader?.innerText.includes("Prosinec")) {
    let cukroviPickUpDates = ["13", "14", "15", "16", "17", "20", "21", "22"];
    for (let dd = 0; dd < array.length; dd++) {
      if (cukroviPickUpDates.includes(array[dd].innerText)) {
        array[dd].closest(".rmdp-day").classList.remove("rmdp-disabled");
        array[dd].closest(".rmdp-day").style.pointerEvents = "all";
      } else {
        array[dd].closest(".rmdp-day").classList.add("rmdp-disabled");
        array[dd].closest(".rmdp-day").style.pointerEvents = "none";
      }
    }
  } else {
    for (let dd = 0; dd < array.length; dd++) {
      array[dd].closest(".rmdp-day").classList.add("rmdp-disabled");
      array[dd].closest(".rmdp-day").style.pointerEvents = "none";
    }
  }
}

function revertCalendar() {
  let array = document.querySelectorAll(".rmdp-day .sd");
  for (let dd = 0; dd < array.length; dd++) {
    array[dd].closest(".rmdp-day").classList.remove("rmdp-disabled");
    array[dd].closest(".rmdp-day").style.pointerEvents = "all";
  }
}
